import { getMemo } from 'Redux/modules/webChat/actions';
import { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

const useGetMemo = () => {
  const { data: memo, status } = useSelector(state => state.webChat.memo, shallowEqual);

  const dispatch = useDispatch();
  const loading = status.getDetails === 0;
  const getMemoDetails = useCallback(
    id => {
      dispatch(getMemo(id));
    },
    [dispatch],
  );

  return {
    memo,
    loading,
    getMemoDetails,
  };
};

export default useGetMemo;
